export default __webpack_public_path__ + "static/media/Gerber Life.e8d37199.svg";